/*
 *  Class Pdp
 */
export
default class Pdp {

    constructor() {
        this.initialLoad = false;
        this.isProduction = process.env.NODE_ENV === 'production';
        this.pdpComponent = document.querySelector('#pdp');
        if (!this.pdpComponent) return;

        this.addToCart = document.querySelector('#pdp-lead__add-to-cart');
        if (!this.addToCart) return;

        if (this.pdpComponent.classList.contains('pdp--device')) {
            this.pageType = 'device';
        } else {
            this.pageType = 'accessory';
        }

        this.baseProductSourceUrl = this.pdpComponent.getAttribute('data-source');
        this.language = this.addToCart.getAttribute('acceptlanguage');
        this.selectedProduct = this.addToCart.getAttribute('productid');
        this.selectedInsurances = [];
        this.carturl = this.addToCart.getAttribute('carturl');

        if (this.pageType === 'device') {
            this.filterAttributes = {
                '30_Interner_Speicher': {
                    name: '',
                    options: {},
                    values: {},
                    infoId: null
                },
                '6_Herstellerfarbe': {
                    name: '',
                    options: {},
                    values: {},
                    infoId: null
                },
                '991_Zustand': {
                    name: '',
                    options: {},
                    values: {},
                    infoId: '#scroll-to-status'
                }
            };
        } else {
            this.filterAttributes = {
                '6_Herstellerfarbe': {
                    name: '',
                    options: {},
                    values: {},
                    infoId: null
                }
            };
        }
        this.attributeList = ['1_Hersteller', '10_Betriebssystem', '4_Herstellernummer', '20_Displaygroesse', '90_SIM_Kartentyp', '3_Artikelnummer', '110_Lieferumfang'];
        this.product = null;
        this.currentArticle = null;
        this.scrollToLinks = document.querySelectorAll('.scroll-to');
        this.filterOptions = document.querySelectorAll('.pdp-lead__select-option');
        this.languageSelectorOptions = document.querySelectorAll('.language-dropdown__item-toggle');
        this.conditionOrder = [
            'originalverpackt', 'wie neu', 'sehr gut', 'gut', 'In Ordnung', 'Schnäppchen', // DE
            'emballage dorigine', 'comme neuf', 'très bien', 'bien', 'usé', 'Bonne affaire', // FR
            'confezione originale', 'come nuovo', 'molto buono', 'buono', 'usato', 'Affarone' // IT
        ];
        this.ATTRIBUTES = {
            MEMORY: '30_Interner_Speicher',
            COLOR: '6_Herstellerfarbe',
            CONDITION: '991_Zustand'
        };
        this.overlay = document.getElementById('overlay');
        this.closeOverlayButton = document.getElementById('close-button');

    }

    orderOptions(type, config) {
        if (this.ATTRIBUTES.MEMORY === type) {
            const sortable = Object.entries(config.options)
            .sort((a, b) => {
                const aa = Number(a[0].replace('GB', '').trim());
                const bb = Number(b[0].replace('GB', '').trim());
                return aa - bb;
            })
            .reduce((r, [k, v]) => {
                return { ...r, [k]: v };
            }, {});
            config.options = sortable;
            config.values = sortable;
        }
        if (this.ATTRIBUTES.CONDITION === type) {
            const options = this.conditionOrder
                .filter(key => {
                    // Case-insensitive search through config.options keys
                    const configKey = Object.keys(config.options).find(
                        k => k.toLowerCase() === key.toLowerCase()
                    );
                    return configKey !== undefined;
                })
                .reduce((obj, key) => {
                    // Find the actual key with correct case from config.options
                    const configKey = Object.keys(config.options).find(
                        k => k.toLowerCase() === key.toLowerCase()
                    );
                    return {
                        ...obj,
                        [configKey]: config.options[configKey]
                    };
                }, {});
            config.options = options;
            config.value = options;
        }
        return config;
    }

    getSelectDom(id, type, config, name) {
        config = this.orderOptions(type, config);

        const selectTitle = document.createElement('span');
        selectTitle.classList.add('pdp-lead__select-title');
        selectTitle.innerText = name || config.name;

        if (config.infoId) {
            const tooltipBody = document.createElement('span');
            tooltipBody.classList.add('pdp-lead__info-tooltip-body');

            const tooltip = document.createElement('span');
            tooltip.classList.add('pdp-lead__info-tooltip');
            tooltip.append(tooltipBody);

            const infoLinkLabel = document.createElement('span');
            infoLinkLabel.innerText = '?';

            const infoLink = document.createElement('a');
            infoLink.href = window.location.href.replace(window.location.hash, '') + config.infoId;
            infoLink.classList.add('pdp-lead__info', 'scroll-to');
            infoLink.append(infoLinkLabel);
            infoLink.append(tooltip);
            infoLink.onmouseover = function() {
              const productId =document.querySelector('#pdp-lead__add-to-cart').getAttribute('productid');
              let optionKey;
              for (const i in config.options) {
                if (config.options[i].indexOf(productId) > -1) {
                  optionKey = i;
                  break;
                }
              }

              let i18n;
              switch(optionKey) {
                case 'original verpackt':
                  i18n = document.querySelector('#pdp-wrap').getAttribute('i18n-tooltip-originalVerpackt');
                  break;

                case 'wie neu':
                  i18n = document.querySelector('#pdp-wrap').getAttribute('i18n-tooltip-wieNeu');
                  break;

                case 'sehr gut':
                  i18n = document.querySelector('#pdp-wrap').getAttribute('i18n-tooltip-sehrGut');
                  break;

                case 'In Ordnung':
                case 'Schnäppchen':
                  i18n = document.querySelector('#pdp-wrap').getAttribute('i18n-tooltip-inOrdnung');
                  break;

                default:
                  i18n = document.querySelector('#pdp-wrap').getAttribute('i18n-tooltip-gut');
              }

              this.querySelector('.pdp-lead__info-tooltip-body').innerHTML = `<i>${optionKey.toUpperCase()}</i>${i18n ? ' ' + i18n : ''}`;

            };
            infoLink.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleScrollTo(infoLink.getAttribute('href'));
            });
            selectTitle.prepend(infoLink);
        }

        const selectGroup = document.createElement('div');
        selectGroup.classList.add('pdp-lead__select-group');
        selectGroup.id = `pdp-lead__filter-id--${id}`;
        for (let i in config.options) {
            const selectOption = document.createElement('a');
            selectOption.href = '#';
            selectOption.classList.add('pdp-lead__select-option');
            selectOption.setAttribute('data-attr', i);
            selectOption.setAttribute('title', i);
            selectOption.setAttribute('data-type', type);
            selectOption.innerText = i;
            if ('6_Herstellerfarbe' === type && config.values[i] && config.values[i][0]) {
              selectOption.classList.add('color');
              selectOption.style.backgroundColor = config.values[i][0];
            }
            if ('30_Interner_Speicher' === type) {
                selectOption.classList.add('memory');
            }
            selectGroup.appendChild(selectOption);
        }

        const select = document.createElement('div');
        select.classList.add('pdp-lead__select');
        select.appendChild(selectTitle);
        select.appendChild(selectGroup);
        return select;
    }

    updateDocumentTitle(productName) {
        let suffixTitle = 'günstig kaufen + Gratisversand';
        if (this.language === 'it-CH') {
            suffixTitle = 'a prezzo vantaggioso + spedizione gratuita';
        }
        if (this.language === 'fr-CH') {
            suffixTitle = 'pas cher + livraison gratuite';
        }
        document.title = `${productName} ${suffixTitle}`;
    }

    updateUrl(productName, newUrl) {
        if (this.initialLoad) {
            // https://gomakethings.com/how-to-update-a-url-without-reloading-the-page-using-vanilla-javascript/
            // window.history.replaceState({
            window.history.pushState({
                id: 'pdp'
            }, null, newUrl);
            this.updateDocumentTitle(productName);

        }
        this.initialLoad = true;
    }

    setFilterSelectorActive(article, withClickEvent) {
        let index = 0;
        let lastEl = null;
        for (let i in this.filterAttributes) {
            for (let ii in this.filterAttributes[i].options) {
                if (this.filterAttributes[i].options[ii].indexOf(article.itemNumber) > -1) {
                    lastEl = document.querySelector(`#pdp-lead__filter-id--${index} a[data-attr='${ii}']`);
                    if (!lastEl) {
                        return;
                    }
                    lastEl.classList.add('active');

                    if (withClickEvent) {
                        lastEl.click();
                    }
                }
            }
            index++;
        }
    }

    getSelectNameFromServer() {
        const selectTitleElements = document.getElementsByClassName('pdp-lead__select-title');
        const selectTitles = [];
        for (const elm of selectTitleElements) {
            const context = elm.innerText.replace('?', '');
            selectTitles.push(context);
        }
        return selectTitles;
    }

    setFilterSelectors() {
        const selectTitles = this.getSelectNameFromServer();
        const filterGroupWrap = document.querySelector('#pdp-lead__selectors');
        filterGroupWrap.innerHTML = '';
        let index = 0;
        for (let i in this.filterAttributes) {
            const config = this.filterAttributes[i];
            const keys = Object.keys(config.values);
            if (config && keys && keys.length) {
                const item = this.getSelectDom(index, i, this.filterAttributes[i], selectTitles[index]);
                filterGroupWrap.appendChild(item);
                index++;
            }
        }
    }

    fetchAllFilterAttributes(itemNumber, attributeGroups) {
        for (let i = 0; i < attributeGroups.length; i++) {
            const articleGroup = attributeGroups[i];

            for (const ii in articleGroup.attributes) {
                const attribute = articleGroup.attributes[ii];
                const attributeKey = attribute.key.replace(/[&\/\\#,+()$~%.'":*?<>{}\r\n]/g, '');

                if (this.filterAttributes[attributeKey] && attribute.value) {
                    const attributeValue = attribute.value.replace(/[&\/\\#,+()$~%.'":*?<>{}\r\n]/g, '');

                    if (!this.filterAttributes[attributeKey].options[attributeValue]) {
                        this.filterAttributes[attributeKey].options[attributeValue] = [];
                        this.filterAttributes[attributeKey].values[attributeValue] = [];
                    }

                    if ('6_Herstellerfarbe' === attributeKey) {
                      const item = articleGroup.attributes.filter((item) => '7_Frontend_Color' === item.key);
                      if (item && item.length) {
                        this.filterAttributes[attributeKey].values[attributeValue].push(item[0].value);
                      }
                    }

                    this.filterAttributes[attributeKey].options[attributeValue].push(itemNumber);
                    this.filterAttributes[attributeKey].name = attribute.name;
                }

                if (attributeKey === '30_Interner_Speicher') {
                  this.filterAttributes[attributeKey].options = Object.fromEntries(Object.entries(this.filterAttributes[attributeKey].options).sort(function(a, b) { return parseInt(a[0]) - parseInt(b[0]); }).reverse());
                }

                if (attributeKey === '991_Zustand') {
                  this.filterAttributes[attributeKey].options = Object.fromEntries(Object.entries(this.filterAttributes[attributeKey].options).sort().reverse());
                }
            }
        }
    }

    updateLanguageSelector() {
      if (!this.languageSelectorOptions || !this.languageSelectorOptions.length) return;

      let currentArticleUrls = null;

      for (let i = 0; i < this.product.articles.length; i++) {
          const article = this.product.articles[i];
          if (this.selectedProduct === article.itemNumber) currentArticleUrls = article.urls;
      }

      if (!currentArticleUrls) return;

      for (let i = 0; i < this.languageSelectorOptions.length; i++) {
          const selector = this.languageSelectorOptions[i];
          const language = selector.querySelector('.language-dropdown__item-toggle-native').getAttribute('lang');
          const articleUrl = currentArticleUrls.filter(item => item.language == language);
          if (articleUrl && articleUrl.length) selector.setAttribute('href', articleUrl[0].url);
      }
    }

    parseProductData(product) {
        this.product = product;

        for (let i = 0; i < product.articles.length; i++) {
            const article = product.articles[i];
            this.fetchAllFilterAttributes(article.itemNumber, article.attributeGroups);
            if (this.selectedProduct === article.itemNumber) this.currentArticle = article;
        }

        this.setFilterSelectors();
        this.handleFilter();
        this.updateLanguageSelector();
        if (this.currentArticle) {
            this.setFilterSelectorActive(this.currentArticle, true);
            this.trackViewItemEvent(this.currentArticle);
        }
        if (this.pageType = 'accessory') {
            this.createJsonLdScript();
        }

        // for test
        // this.showRecommendationOverlay();
    }

    async fetchProductData(callback) {
        const source = `${this.baseProductSourceUrl}${this.selectedProduct}`;
        try {
            const response = await fetch(source, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': this.language
                }
            });
            if (response.ok) {
                const result = await response.json();
                callback(result.data ? result.data : null);
            }
        } catch (error) {
            console.error('Error fetching product data:', error);
        }
    }

    toggleFilterOptionStates(currentSelectedItem) {
        const currentSelectedGroup = currentSelectedItem.parentNode;
        const selectedProperty = currentSelectedItem.getAttribute('data-attr'); // f.e. '256 GB', 'Green', ...
        const productIds = [];
        const validProductIds = [];
        const validProductConfigurations = [];
        const filterOptionId = 'pdp-lead__filter-id--';

        let index = 0;

        // Loop trough filterAttributes to build selected filter option afterwards
        // Collect all productIds and sort them into available (productIds) and valid (validProductIds)
        index = 0;
        for (const attrKey in this.filterAttributes) {
            index++;

            for (const attrPropertyKey in this.filterAttributes[attrKey].options) {
                for (let i = 0; i < this.filterAttributes[attrKey].options[attrPropertyKey].length; i++) {
                    const productId = this.filterAttributes[attrKey].options[attrPropertyKey][i];
                    // Add product id to visible product id list
                    if (productIds.indexOf(productId) === -1) {
                        productIds.push(productId);
                    }

                    // Check if the current property is part of the selection by the user
                    // If it is the case add it to valid product id list
                    if (attrPropertyKey === selectedProperty) {
                        if (validProductIds.indexOf(productId) === -1) {
                            validProductIds.push(productId);
                        }
                    }
                }
            }
        }

        // Find all items which fullfill the min requirements:
        // Min requirement is to match at least 1 of 3 configuration options
        // Store all such valid items in 'validProductConfigurations'
        const threshold = 2;
        const minRequiredHits = Object.keys(this.filterAttributes).length - threshold;
        const thresholdHits = minRequiredHits > 0 ? minRequiredHits : 0;
        for (let i = 0; i < productIds.length; i++) {
            const productId = productIds[i];
            let hits = 0;

            index = 0;
            for (const attrKey in this.filterAttributes) {
                const activeFilterItem = document.querySelector(`#pdp-lead__filter-id--${index} a.active`);
                if (activeFilterItem) {
                    const itemAttr = activeFilterItem.getAttribute('data-attr');
                    const filterOptions = this.filterAttributes[attrKey].options[itemAttr];
                    if (filterOptions.indexOf(productId) > -1) {
                        hits++;
                    }
                }
                index++;

            }

            // Configuration must meet min requirements to be visible as valid configuration
            if (hits >= thresholdHits) {
                validProductConfigurations.push(productId);
            }
        }

        // Enable/Disable filter options
        index = 0;
        for (const attrKey in this.filterAttributes) {
            const allFilterItems = document.querySelectorAll(`#${filterOptionId}${index} a`);
            index++;

            // Select filter item
            for (const item of allFilterItems) {
                item.classList.remove('enable');
                item.setAttribute('disabled', true);
                const itemAttr = item.getAttribute('data-attr');
                const filterOptions = this.filterAttributes[attrKey].options[itemAttr];
                let isSelectable = false;
                let isEnabled = false;

                // Check filter options
                for (let ii = 0; ii < filterOptions.length; ii++) {
                    const productId = filterOptions[ii];

                    // If option fullfill min requirement it should be visible and selectable
                    const isValidItem = validProductConfigurations.indexOf(productId) > -1;
                    if (isValidItem && !isSelectable) isSelectable = true;

                    // If option is also already a valid option it should be enabled
                    const isValidConfig = validProductIds.indexOf(productId) > -1;
                    if (isValidConfig && !isEnabled) isEnabled = true;
                }

                // FYI: The presentation works in two layers.
                // First layer is to define what options shouldd be selectable
                // Second layer is to define which of the selectable option are also enabled

                // Set option to visible and selectable
                if (isSelectable) {
                  item.removeAttribute('disabled');

                }

                // Set option do be displayed as active/enabled (full opacity)
                if (isEnabled) {
                    item.classList.add('enable');

                }
            }
        }

        // Check preselection
        // The idea here is, we start with the option, which was click by the user, as main option
        // And then go down all options and click the first valid option if no selection is set
        // To make sure at the end we have a valid configuration
        // Not sure if this is a smart move
        for (let i = 0; i < Object.keys(this.filterAttributes).length; i++) {
            const activeElement = document.querySelector(`#${filterOptionId}${i} a.active.enable:not([disabled])`);
            if (!activeElement) {
              if (document.querySelector(`#${filterOptionId}${i} a.enable`)) {
                document.querySelector(`#${filterOptionId}${i} a.enable`).click();

              }
              break;

            }
        }
    }

    getOptionEnabledByProductIds(selectedProductIds) {
        const optionEnabled = [];
        Object.keys(this.filterAttributes).forEach((key) => {
            const optionKeys = Object.keys(this.filterAttributes[key].options);
            optionKeys.forEach(optionKey => {
                const optionValues = this.filterAttributes[key].options[optionKey];
                const productIds = selectedProductIds.filter(
                    (selectedProductId) =>
                        optionValues.filter((optionValue) => selectedProductId === optionValue)
                            .length
                );
                if (productIds && productIds.length && optionEnabled.indexOf(key) === -1) {
                    optionEnabled.push(optionKey);
                }
            });
        });
        return optionEnabled;
    }

    removeEnableAndDisabledFilterOptions(items) {
        for(const item of items) {
            item.classList.remove('enable');
            item.setAttribute('disabled', true);
        }
    }

    enableAndRemoveDisabledFilterOptions(items) {
        for(const attr of items) {
            const option = document.querySelector(`[data-attr="${attr}"]`);
            option.classList.add('enable');
            option.removeAttribute('disabled');
        }
    }

    removeActiveFilterOptions(items) {
        for(const item of items) {
            item.classList.remove('active');
        }
    }

    activeFirstFilterOptions(leadFilterId) {
        const active = leadFilterId.getElementsByClassName('active');
        if (active && active.length) {
            active[0].click();
        }
        if (active && !active.length) {
            const options = leadFilterId.getElementsByClassName('enable');
            options[0].classList.add('active');
        }
    }

    toggleFilterOptionStatesNew(selectedItem) {
        const selectedItemAttr = selectedItem.getAttribute('data-attr');
        const selectedItemType = selectedItem.getAttribute('data-type');
        const attrs = this.filterAttributes[selectedItemType];
        let selectedProductIds = [];
        if (attrs) {
            selectedProductIds = attrs.options[selectedItemAttr];
        }

        let optionEnabled = [];
        const otherFilterOptionProductIds = [];
        let otherFilterOptionKeys = '';

        // find product id by memory is active
        const memoryIsActive = document.querySelector('.active[data-type="' + this.ATTRIBUTES.MEMORY + '"]');
        const attr = memoryIsActive.getAttribute('data-attr');
        const memoryIsActiveProductIds = this.filterAttributes[this.ATTRIBUTES.MEMORY].options[attr];

        // find key is not selected and not memory
        otherFilterOptionKeys = Object.keys(this.filterAttributes).filter(
            (key) => key !== selectedItemType && key !== this.ATTRIBUTES.MEMORY
        );
        for (const filterKey of otherFilterOptionKeys) {
            const options = this.filterAttributes[filterKey].options;
            Object.keys(options).forEach(optionKey => {
                const optionValues = options[optionKey];
                optionValues.forEach(value => {
                    const inMemory = memoryIsActiveProductIds.indexOf(value) !== -1;
                    const inSelected = selectedProductIds.indexOf(value) !== -1;
                    const inAdded = otherFilterOptionProductIds.indexOf(value) === -1;
                    if (inMemory && inSelected && inAdded) {
                        otherFilterOptionProductIds.push(value);
                    }
                });
            });
        }

        if (otherFilterOptionProductIds.length && otherFilterOptionKeys) {
            // toggle disable, enable class, active class to filter option is not selected and not memory
            otherFilterOptionKeys.forEach(key => {
                const index = Object.keys(this.filterAttributes).indexOf(key);
                if (index !== -1) {
                    const leadFilterId = document.getElementById('pdp-lead__filter-id--' + index);

                    // remove enable, disabled
                    const allFilterItems = leadFilterId.getElementsByClassName('pdp-lead__select-option');
                    this.removeEnableAndDisabledFilterOptions(allFilterItems);

                    // add enable class, disabled attr to option's filter
                    optionEnabled = this.getOptionEnabledByProductIds(otherFilterOptionProductIds);
                    this.enableAndRemoveDisabledFilterOptions(optionEnabled);

                    // remove active
                    const itemDisabled = leadFilterId.querySelectorAll(
                        '.pdp-lead__select-option[disabled]'
                    );
                    this.removeActiveFilterOptions(itemDisabled);

                    // active
                    this.activeFirstFilterOptions(leadFilterId);
                }
            });
        }
    }

    showElement(el) {
        el.classList.remove('hidden');
    }

    hideElement(el) {
        el.classList.add('hidden');
    }

    setAreaTextContent(selector, text) {
        const el = document.querySelector(selector);
        if (!text.length) this.hideElement(el);
        if (text.length) this.showElement(el);
        el.innerHTML = text;
    }

    priceFormat(priceValue, currencyLabel) {
        // return priceValue.toLocaleString('de-CH', { style: 'currency', currency: currencyLabel}).replace(/\.0+$/, '');
        const suffix = Number(priceValue) % 1 === 0 ? '.-' : '';
        return new Intl.NumberFormat('de-CH').format(priceValue) + suffix;
    }

    setPrice(selector, price, currency) {
        selector.querySelector('.pdp-lead__price-value').innerText = this.priceFormat(parseFloat(price), currency);
        selector.querySelector('.pdp-lead__price-currency').innerText = '';
    }

    getInsuranceItem(id, name, itemnumber) {
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.id = id;
        input.name = id;
        input.value = itemnumber;

        const label = document.createElement('label');
        label.setAttribute('for', id);
        label.innerText = name;
        label.classList.add('pdp-lead__insurance-item-label');

        const div = document.createElement('div');
        div.classList.add('pdp-lead__insurance-item');
        div.appendChild(input);
        div.appendChild(label);

        return div;
    }

    updateAddToCartSelects() {
        const addToCart = document.querySelector('#pdp-lead__add-to-cart');
        addToCart.setAttribute('productid', this.selectedProduct);
        addToCart.setAttribute('insurance', this.selectedInsurances.join(','));
    }

    getImgSrc(asset) {
        return `${asset.url.replace('{stack}', 'large')}/${asset.slug}.jpg`;
    }

    getImageMainItem(id, active, asset) {
        const input = document.createElement('input');
        input.type = 'radio';
        input.id = id;
        input.name = 'pdp-image-group';
        if (active) input.setAttribute('checked', true);

        const img = document.createElement('img');
        img.classList.add('image-box__image');
        img.src = this.getImgSrc(asset);

        // disable lazy loading of the first product image which is a LCP element
        if (!active) {
            img.loading = 'lazy';
        }

        const div = document.createElement('div');
        div.classList.add('image-box__item');
        div.appendChild(input);
        div.appendChild(img);

        return div;
    }

    getImageMenuItem(id, active, asset) {
        const img = document.createElement('img');
        img.classList.add('image-box__preview');
        img.src = this.getImgSrc(asset);
        img.loading = 'lazy';

        const label = document.createElement('label');
        label.setAttribute('for', id);
        label.appendChild(img);

        return label;
    }

    getAttrByKey(key, attributes) {
      return attributes.filter(attr => key === attr.key);
    }

    getUnit(unit) {
        if (unit === 'Zoll') {
            if (this.language === 'fr-CH') {
                return 'pouces';
            }
            if (this.language === 'it-CH') {
                return 'pollici';
            }
            return unit;
        }
        return unit || '';
    }

    printProductPage(product, skipUpdateURL) {
        this.trackViewItemEvent(product);
        skipUpdateURL = skipUpdateURL || false;
        const brand = this.getAttrByKey('1_Hersteller', product.attributeGroups[0].attributes)[0]?.value;
        this.setAreaTextContent('#pdp-lead__title', `${brand} ${product.name}`);
        // this.setAreaTextContent('#pdp-lead__subtitle', product.description);
        this.setAreaTextContent('#pdp-description__text p', product.longDescription);

        const imageBox = document.querySelector('#pdp-lead__image-box');
        if (product.assets.length) {
            const imageBoxMain = imageBox.querySelector('.image-box__main');
            const imageBoxMenu = imageBox.querySelector('.image-box__menu');
            imageBoxMain.innerHTML = '';
            imageBoxMenu.innerHTML = '';
            for (let i = 0; i < product.assets.length; i++) {
                imageBoxMain.appendChild(this.getImageMainItem(`image-box-${i}`, i == 0, product.assets[i]));
                imageBoxMenu.appendChild(this.getImageMenuItem(`image-box-${i}`, i == 0, product.assets[i]));
            }
            this.showElement(imageBox);
        } else {
            this.hideElement(imageBox);
        }

        // const insurance = document.querySelector('#pdp-lead__insurance');
        // if (product.insurances.length) {
        //     const insuranceList = document.querySelector('#pdp-lead__insurance-items');
        //     insuranceList.innerHTML = '';
        //     for (let i = 0; i < product.insurances.length; i++) {
        //         insuranceList.appendChild(this.getInsuranceItem(`insurance-${i}`, product.insurances[i].name, product.insurances[i].itemNumber))
        //     }
        //     this.showElement(insurance);
        // } else {
        //     this.hideElement(insurance);
        // }

        const addToCart = document.querySelector('#pdp-lead__add-to-cart');
        const flag = document.querySelector('#pdp-lead__flag');
        const priceTotal = document.querySelector('#pdp-lead__price-total');
        const priceDiscount = document.querySelector('#pdp-lead__price-discount');
        this.hideElement(addToCart);
        this.hideElement(flag);
        this.hideElement(priceTotal);
        this.hideElement(priceDiscount);
        if (product.price) {
            this.showElement(addToCart);
            this.showElement(priceTotal);

            if (product.price.salesPriceDiscounted) {
                this.setPrice(priceTotal, product.price.salesPriceDiscounted, product.price.currency);
                this.setPrice(priceDiscount, product.price.salesPrice, product.price.currency);
                this.showElement(priceDiscount);
                this.showElement(flag);
            } else {
                this.setPrice(priceTotal, product.price.salesPrice, product.price.currency);
            }
        }

        const attributeList = document.querySelector('#pdp-description__attributes');
        attributeList.innerHTML = '';
        const dl = document.createElement('dl');
        for (let i = 0; i < product.attributeGroups.length; i++) {
            const attrs = product.attributeGroups[i].attributes;
            this.attributeList.forEach(key => {
                const attr = attrs.find(attr => attr.key === key);
                if (attr) {
                    const name = attr.name;
                    const value = attr.value || '';
                    const unit = this.getUnit(attr.unit);
                    const dt = document.createElement('dt');
                    const dd = document.createElement('dd');
                    dt.innerHTML = name;
                    dd.innerText = `${value} ${unit}`;
                    dl.appendChild(dt);
                    dl.appendChild(dd);
                }
            });
        }
        attributeList.appendChild(dl);

        for (let i = 0; i < product.urls.length; i++) {
            if (product.urls[i].language === this.language) {
                const url = product.urls[i].url;
                // const url = product.urls[i].url.substring(3);
                const manufacturer = product.attributeGroups[0].attributes.find(attr => attr.key === '1_Hersteller').value;
                if (!skipUpdateURL) {
                    this.updateUrl(`${manufacturer} ${product.name}`, `${this.isProduction ? '' : '?dev:'}${url}`);
                }
                this.selectedProduct = product.itemNumber;
                this.updateAddToCartSelects();
                break;
            }
        }

        const properties = document.querySelector('.pdp-lead__properties');
        const attributePower = () => {
            const attrKey = '1001_Akku_jusit';
            let result = [];
            if (product.attributeGroups[0]) {
                result = this.getAttrByKey(attrKey, product.attributeGroups[0].attributes);
            }
            return result;
        };

        const svgPower = properties.querySelector('.icon__fa-solid--battery-full');
        if (svgPower) {
            svgPower.closest('li').remove();
        }

        if (attributePower.length && '-hidden-' !== attributePower[0].value) {
            const li = document.createElement('li');
            li.innerHTML = '<svg class="icon-sprite icon__fa-solid--battery-full"><use xlink:href="#icon__fa-solid--battery-full"></use></svg> ' + attributePower[0].value;
            properties.append(li);
        }
    }

    handleStatusContext() {
        const pdpWrap = document.getElementById('pdp-wrap');
        const available = document.getElementById('pdp-lead__status--available');
        const notAvailable = document.getElementById('pdp-lead__status--not-available');
        if (!available || !notAvailable) {
            return;
        }

        const statusAvailable = pdpWrap.getAttribute('i18n-status-available');
        const statusNotAvailable = pdpWrap.getAttribute('i18n-status-not-available');
        available.querySelector('span').innerHTML = statusAvailable;
        notAvailable.querySelector('span').innerHTML = statusNotAvailable;
    }

    handleStatus(productId) {
        const available = document.getElementById('pdp-lead__status--available');
        const notAvailable = document.getElementById('pdp-lead__status--not-available');
        if (!available || !notAvailable) {
            return;
        }
        const addToCartWrap = document.getElementById('pdp-lead__add-to-cart-wrap');
        const price = document.querySelector('.pdp-lead__price');
        if (productId) {
            available.classList.add('active');
            notAvailable.classList.remove('active');
            addToCartWrap.classList.remove('disabled');
            price.classList.add('active');
            return;
        }
        available.classList.remove('active');
        notAvailable.classList.add('active');
        addToCartWrap.classList.add('disabled');
        price.classList.remove('active');
    }

    getProductIdByFilters() {
        const selectors = {};
        let index = 0;
        // see for each itemNumber, which one has how many '.active' filter element
        for (let i in this.filterAttributes) {
            const filter = document.querySelector(`#pdp-lead__filter-id--${index}`);
            if (filter) {
                const activeFilter = filter.querySelector('a.active');
                index++;
                if (!activeFilter) continue;

                const filterItem = activeFilter.getAttribute('data-attr');
                const activeFilterAttribute = this.filterAttributes[i].options[filterItem];

                if (!activeFilterAttribute) {
                    continue;
                }

                for (let ii = 0; ii < activeFilterAttribute.length; ii++) {
                    const option = activeFilterAttribute[ii];
                    if (!selectors[option]) selectors[option] = 0;
                    selectors[option]++;
                }
            }
        }

        // const selectorsSorted = Object.keys(selectors).sort(function (a, b) {
        //     return selectors[b] - selectors[a];
        // });
        // return selectorsSorted[0] ? selectorsSorted[0] : null;

        const filterAttributes = Object.keys(this.filterAttributes).length;
        const productId = Object.keys(selectors).find(key => {
            const value = selectors[key];
            if (Number(value) === filterAttributes) {
                return key;
            }
        });
        return productId;
    }

    handleFilter(selectedProductId) {
        const productId = selectedProductId || this.getProductIdByFilters();
        this.handleStatus(productId);
        if (!productId) {
            return;
        };
        const product = this.product.articles.filter(product => product.itemNumber === productId);
        this.selectedInsurances = []; // Reset selected insurance selection
        if (product[0]) {
            // when manually selecting product, skip writing window.history
            const skipUpdateURL = Boolean(selectedProductId);
            this.printProductPage(product[0], skipUpdateURL);
            this.currentArticle = product[0];
        } else {
            console.error('No valid product found with current configuration.');
        }
    }

    handleFilterClick(e) {
        e.preventDefault();
        // memory is always clickable
        // const isMemory = e.target.classList.contains('memory');
        // if (e.target.getAttribute('disabled') && !isMemory) {
        //     return;
        // }
        const activeNode = e.target.parentNode.querySelector('.active');
        if (activeNode) {
            activeNode.classList.remove('active');
        };
        e.target.classList.add('active');
        // this.toggleFilterOptionStates(e.target);
        // this.toggleFilterOptionStatesNew(e.target);
        this.handleFilter();
        this.createJsonLdScript();
    }

    handleAttributeTabLabelClick(e) {
      const labels = document.querySelectorAll('.pdp-description__tab-label');
      for (const label of labels) {
        label.classList.remove('active');
      }
      e.target.classList.add('active');
    }

    handleInsuranceClick(e) {
        const checkbox = document.querySelector(`#${e.target.getAttribute('for')}`);
        const i = this.selectedInsurances.indexOf(checkbox.value);
        if (!checkbox.checked) {
            if (i === -1) this.selectedInsurances.push(checkbox.value);
        } else {
            if (i > -1) this.selectedInsurances.splice(i, 1);
        }

        this.updateAddToCartSelects();
    }

    handleScrollTo(href) {
        if (!href) return;

        const id = href.split('#')[1];
        if (!id) return;

        const statusContent = document.querySelector(`#${id}`);
        if (!statusContent) return;

        const rect = statusContent.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const scrollTopOffset = 160; // add offset to prevent overlapping with the header

        window.scrollTo({
            top: rect.top + scrollTop - scrollTopOffset,
            behavior: 'smooth'
        });
    }

    handleClickEvents(event) {
        if (event.target.matches('.scroll-to')) {
            event.preventDefault();
            event.stopPropagation();
            this.handleScrollTo(event);
            return;
        }
        if (event.target.matches('.pdp-lead__select-option')) this.handleFilterClick(event);
        if (event.target.matches('.pdp-lead__insurance-item-label')) this.handleInsuranceClick(event);
        if (event.target.matches('.pdp-description__tab-label')) this.handleAttributeTabLabelClick(event);
    }

    /**
     * manually set active article when clicking on the browser's back button.
     * in this case the URL changes to the previous item but it doesn't trigger click events on filter items.
     * we have to manually set active filter items using the new itemNumber.
     */
    handleBackButton() {
        window.addEventListener('popstate', (e) => {
            const parts = window.location.href.split('/');
            const newItemNumber = parts.pop();
            if (this.selectedProduct === newItemNumber) {
                return;
            }

            // manually select product
            const newArticle = this.product.articles.find(article => article.itemNumber === newItemNumber);
            if (!newArticle) {
                return;
            }
            this.selectedProduct = newItemNumber;
            this.setFilterSelectors();
            this.handleFilter(this.selectedProduct);
            this.updateLanguageSelector();
            this.setFilterSelectorActive(newArticle, false);
        });
    }

    init() {
        if (!this.pdpComponent) return;
        if (!this.addToCart) return;
        this.handleStatusContext();
        document.addEventListener('click', this.handleClickEvents.bind(this), false);
        this.fetchProductData(this.parseProductData.bind(this));
        this.handleBackButton();
        this.handleEventAddToCart();
        this.handleReadMoreButton();
    }

    trackViewItemEvent(product) {

        // don't track twice when the PDP is re-rendered on client side for the same product
        if (product.itemNumber === this.trackedItemnumber) {
            return;
        }

        const url = product.urls.find(url => url.language === this.language).url;
        const urlParts = new URL(url).pathname.split('/');
        const category = urlParts[2];
        const manufacturer = urlParts[3];
        const model = urlParts[4];

        const item = {
            item_id: product.itemNumber,
            item_name: product.name,
            item_category: category,
            item_category2: manufacturer,
            item_category3: model,
            currency: product.price.currency,
            quantity: 1,
            price: product.price.salesPriceDiscounted || product.price.salesPrice,
            concrete_sku: product.itemNumber,
            offer_type: 'hardware-only',
            availability: this.mapAvailabilityStatusToAnalytics(product.availabilityStatus)
        };

        if (product.price.salesPriceDiscounted) {
            const discount = (product.price.salesPrice - product.price.salesPriceDiscounted).toFixed(2);
            item.discount = parseFloat(discount);
        }

        const productAttributes = product.attributeGroups[0].attributes;
        const brand = productAttributes.find(attr => attr.key === '1_Hersteller');
        if (brand && brand.value) {
            item.item_brand = brand.value;
        }

        const eanCode = productAttributes.find(attr => attr.key === '5_EAN_Code');
        if (eanCode) {
            item.ean = eanCode.value;
        }

        const color = productAttributes.find(attr => attr.key === '6_Herstellerfarbe');
        const memory = productAttributes.find(attr => attr.key === '30_Interner_Speicher');

        let variant;
        if (color && color.value && memory && memory.value) {
            variant = `${color.value}|${memory.value}`;
        } else if (color && !memory) {
            variant = color.value;
        } else if (!color && memory) {
            variant = memory.value;
        } else {
            variant = null;
        }

        if (variant) {
            item.item_variant = variant;
        }

        if (color && color.value) {
            item.color = color.value;
        }

        if (memory && memory.value) {
            item.memory_variant = memory.value;
        }

        // see related implementation in jusit-frontend-widgets repo. search for `storeTrackingParams` method
        const storedTrackingParams = sessionStorage.getItem('trackingParams');
        if (storedTrackingParams) {
            const params = JSON.parse(storedTrackingParams);
            if (params.item_id === item.item_id) {
                item.index = params.index;
                item.item_list_id = params.item_list_id;
                item.item_list_name = params.item_list_name;
            }
        }

        // keep track of the last product that was tracked to avoid tracking the same product twice
        this.trackedItemnumber = product.itemNumber;

        const eventData = {
            event: 'view_item',
            ecommerce: {
                items: [item]
            }
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(eventData);
    }

    mapAvailabilityStatusToAnalytics(status) {
        if (status === 'not_available') {
          return 'OutOfStock';
        }

        if (status === 'preorder_available') {
          return 'PreOrder';
        }

        if (status === 'reorder_available' || status === 'reorder_available_unknown') {
          return 'BackOrder';
        }

        return 'InStock';
    }

    getProductDataForJsonLdScript() {
        let salesPrice = parseFloat(this.currentArticle.price.salesPrice);
        if (this.currentArticle.price.salesPriceDiscounted) {
            salesPrice = parseFloat(this.currentArticle.price.salesPriceDiscounted);
        }
        const price = salesPrice.toLocaleString('de-CH').replace(/\.0+$/, '').replace(/(\'|\’)/, '');
        const itemNumber = this.currentArticle.itemNumber;
        const name = this.currentArticle.name;
        const description = this.currentArticle.description;
        const image = this.getImgSrc(this.currentArticle.assets[0]);
        const urlObj = this.currentArticle.urls.find(url => url.language === this.language);
        const attribute = this.currentArticle.attributeGroups[0].attributes.find(attribute => attribute.key === '1_Hersteller');
        const brand = attribute.value;

        return {
            price,
            itemNumber,
            name,
            description,
            image,
            url: urlObj.url,
            brand
        };
    }

    createJsonLdScript() {
        if (!this.currentArticle) {
            return;
        }

        const scriptSelector = document.querySelector('[type="application/ld+json"]');
        if (scriptSelector) {
            scriptSelector.remove();
        }

        const {
            price,
            itemNumber,
            name,
            description,
            image,
            url,
            brand
        } = this.getProductDataForJsonLdScript();

        const script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.textContent = `{
            "@context": "http://schema.org",
            "@type": "Product",
            "name": "${name}",
            "description": "${description}",
            "sku": "${itemNumber}",
            "image": "${image}",
            "offers": {
              "@type": "Offer",
              "availability": "https://schema.org/InStock",
              "price": ${price},
              "priceCurrency": "CHF",
              "url": "${url}",
              "itemCondition": "https://schema.org/RefurbishedCondition"
            },
            "brand": { "@type": "Brand", "name": "${brand}" }
          }`;
        document.head.appendChild(script);
    }

    setProductContext(product) {
        const image = document.getElementById('overlay-product-image');
        image.src = this.getImgSrc(product.assets[0]);
        let price = 0;
        if (product.price) {
            if (product.price.salesPriceDiscounted) {
                price = this.priceFormat(parseFloat(product.price.salesPriceDiscounted));
            } else {
                price = this.priceFormat(parseFloat(product.price.salesPrice));
            }
        }
        const brand = this.getAttrByKey('1_Hersteller', product.attributeGroups[0].attributes)[0]?.value;
        const Interner_Speicher = this.getAttrByKey('30_Interner_Speicher', product.attributeGroups[0].attributes)[0]?.value;
        const Herstellerfarbe = this.getAttrByKey('6_Herstellerfarbe', product.attributeGroups[0].attributes)[0]?.value;
        const Displaygroesse = this.getAttrByKey('20_Displaygroesse', product.attributeGroups[0].attributes)[0]?.value;
        const SIM_Kartentyp = this.getAttrByKey('90_SIM_Kartentyp', product.attributeGroups[0].attributes)[0]?.value;
        const name = `${product.name} (${Interner_Speicher}, ${Herstellerfarbe}, ${Displaygroesse}, ${SIM_Kartentyp})`;

        this.setAreaTextContent('#overlay-price', price);
        this.setAreaTextContent('#overlay-brand', brand);
        this.setAreaTextContent('#overlay-name', name);

        const link = document.querySelector('.recommendation-overlay__checkout');
        const lang = this.language.split('-')[0];
        link.href = `/${lang}/cart.html`;
    }

    setInsurancesContext(product) {
        const insuranceElm = document.getElementById('insurances');
        insuranceElm.innerHTML = '';

        const insurances = product.insurances;

        if (!insurances || (insurances && !insurances.length)) {
            const insuranceElmWrapper = document.getElementById('insurances-wrapper');
            insuranceElmWrapper.style.display = 'none';
            return;
        }

        const maximumOfInsurances = 2;
        const inSuranceList = insurances.slice(0, maximumOfInsurances);
        for (let index = 0; index < inSuranceList.length; index++) {
            const insurance = inSuranceList[index];
            const attributes = insurance.attributes;
            let Laufzeit;
            let Selbstbehalt;
            let Wasserschäden;
            let Displayschäden;
            let Diebstahl;
            let Booklets;
            if (attributes) {
                Laufzeit = attributes.find(m => m.key === '190_Laufzeit');
                Selbstbehalt = attributes.find(m => m.key === '191_Selbstbehalt');
                Wasserschäden = attributes.find(m => m.key === '196_Wasserschäden');
                Displayschäden = attributes.find(m => m.key === '197_Displayschäden');
                Diebstahl = attributes.find(m => m.key === '199_Diebstahl');
                Booklets = attributes.find(m => m.key === '201_Booklets');
            }

            const addToCartText = this.addToCart.querySelector('span').textContent;

            const html = `<div class="recommendation-overlay__insurances-item">
                <div class="recommendation-overlay__insurances-image">
                    <img src="${insurance.assets[0].url.replace('{stack}', 'product-detail-accessory-card')}/image.jpg" alt="${insurance.name}">
                </div>
                <div class="recommendation-overlay__insurances-content">
                    <p class="recommendation-overlay__insurances-name">${insurance.name}</p>
                    <p class="recommendation-overlay__insurances-price">${this.priceFormat(parseFloat(insurance.price.salesPrice))}</p>
                    <ul class="recommendation-overlay__insurances-list">
                        ${ Laufzeit ? '<li>' + Laufzeit.name + ': ' + Laufzeit.value + '</li>' : '' }
                        ${ Selbstbehalt ? '<li>' + Selbstbehalt.name + ': ' + Selbstbehalt.value + '</li>' : '' }
                        ${ Wasserschäden ? '<li>' + Wasserschäden.name + ': ' + Wasserschäden.value + '</li>' : '' }
                        ${ Displayschäden ? '<li>' + Displayschäden.name + ': ' + Displayschäden.value + '</li>' : '' }
                        ${ Diebstahl ? '<li>' + Diebstahl.name + ': ' + Diebstahl.value + '</li>' : '' }
                    </ul>
                    ${
                        Booklets ? '<a class="recommendation-overlay__insurances-document" href="' + Booklets.value +'" download>'+ Booklets.name +'</a>' : ''
                    }
                    <div class="recommendation-overlay__insurances-action">
                        <app-addtocart carturl="${this.carturl}" acceptlanguage="${this.language}" productid="${this.selectedProduct}" insuranceids="${insurance.itemNumber}" area="widget">
                            <span class="recommendation-overlay__insurances-add-to-cart">${addToCartText}</span>
                        </app-addtocart>
                    </div>
                </div>
            </div>`;

            insuranceElm.insertAdjacentHTML('beforeend', html);
        }
    }

    setProductSliderContext() {
        const sliderContainerElm = document.getElementById('recommendation-overlay-slider');
        sliderContainerElm.innerHTML = '';

        const addToCartText = this.addToCart.querySelector('span').textContent;

        const html = `<app-multiple-product-slider class="widget widget-multiple-product-slider jusit-company-widget-multipleproductslider" acceptlanguage="${this.language}" discount="0" itemtype="Accessory" specificarticles="${this.selectedProduct}" btnlabel="${addToCartText}" carturl="${this.carturl}" showaccessoriesbyarticle="1" _nghost-jpa-c3="" ng-version="13.3.12"></app-multiple-product-slider>`;

        sliderContainerElm.insertAdjacentHTML('beforeend', html);

    }

    setRecommendationOverlayContext() {
        const product = this.product.articles.find(product => product.itemNumber === this.selectedProduct);
        if (product) {
            this.setProductContext(product);
            this.setInsurancesContext(product);
            this.setProductSliderContext();
        }
    }

    showRecommendationOverlay() {
        if (this.product) {
            this.setRecommendationOverlayContext();
            this.overlay.style.display = 'flex';
            document.querySelector('body').classList.add('overflow-hidden');
        }
    }

    hideRecommendationOverlay() {
        this.overlay.style.display = 'none';
        document.querySelector('body').classList.remove('overflow-hidden');
    }

    handleCloseOverlayButton() {
        this.closeOverlayButton.addEventListener('click', () => {
            this.hideRecommendationOverlay();
        });
    }

    handleEventAddToCart() {
        window.addEventListener('addToCart', (e) => {
            if (e.detail.msg.state === 'success' && e.detail.area !== 'widget') {
                this.showRecommendationOverlay();
                this.handleCloseOverlayButton();
            }
        }, false);
    }

    handleReadMoreButton() {
        const showMoreBtn = document.getElementById('pdp-description__toggle-show-more');
        const readMoreContext = document.getElementById('pdp-description__text');
        if (showMoreBtn && readMoreContext) {
            const showMoreText = showMoreBtn.querySelector('.show-more');
            const showLessText = showMoreBtn.querySelector('.show-less');

            switch (this.language) {
                case 'fr-CH':
                    showMoreText.innerHTML = 'afficher plus';
                    showLessText.innerHTML = 'voir moins de';
                    break;
                case 'it-CH':
                    showMoreText.innerHTML = 'mostra di più';
                    showLessText.innerHTML = 'mostra meno';
                    break;
                default:
                    showMoreText.innerHTML = 'mehr anzeigen';
                    showLessText.innerHTML = 'weniger anzeigen';
                    break;
            }

            showMoreBtn.addEventListener('click', () => {
                readMoreContext.classList.toggle('closed');
            });
        }
    }
}
